export default "__VITE_ASSET__Dqobl1e0__"